module.exports = __webpack_public_path__ + "static/img/search-nodata-iscourse.8a6f011a.png";